export const DO_GET_MENU = "DO_GET_MENU";
export const DO_GET_MENU_SUCCESS = "DO_GET_MENU_SUCCESS";
//job
export const DO_SET_JOB = "DO_SET_JOB";
export const DO_SET_JOB_SUCCESS = "DO_SET_JOB_SUCCESS";

//store
export const DO_CHOOSE_STORE = "DO_CHOOSE_STORE";
export const DO_CHOOSE_STORE_SUCCESS = "DO_CHOOSE_STORE_SUCCESS";
